import {
  Box,
  Flex,
  IconButton,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { FaTimes } from "react-icons/fa";

type ModalWrapperProps = {
  onOpen?: () => void;
  onClose: () => void;
  withOverlay?: boolean;
  withCloseButton?: boolean;
  isOpen: boolean;
  children: ReactNode;
  title?: string;
  size?: string;
  isCentered?: boolean;
};

const ModalWrapper = (props: ModalWrapperProps) => {
  const {
    isOpen,
    onClose,
    title,
    size = "lg",
    withOverlay = true,
    withCloseButton = true,
    isCentered = false,
  } = props;
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      isCentered={isCentered}
      size={isLargerThan900 ? size : "full"}
    >
      {withOverlay && isLargerThan900 && <ModalOverlay />}
      <ModalContent overflowY="auto">
        <Flex justifyContent={"space-between"} alignItems="center" p="3">
          <Text fontWeight={"bold"} fontSize="lg">
            {title}
          </Text>

          {withCloseButton && (
            <IconButton
              aria-label="Close Buton"
              onClick={onClose}
              icon={<FaTimes />}
            />
          )}
        </Flex>
        {props.children}
      </ModalContent>
    </Modal>
  );
};

export default ModalWrapper;
